import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import ExpertOpinion from 'features/expertOpinion';

const ExpertOpinionPage = () => (
  <MainLayout>
    <ExpertOpinion />
  </MainLayout>
);

export default ExpertOpinionPage;
